import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../../../app/store';
import fetchAPI from "../../../common/fetchAPI";
import { WorkingDayTypeStateClass } from "./interfaces/workingdaytypeStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: WorkingDayTypeStateClass = {
    isLoading: false,
    status: 'idle',
    workingdaytypeList: [],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'AccountWorkingDayType',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        workingdaytype: WorkingDayTypeStateClass;
    },
}

export const getAccountWorkingDayTypesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'TimeSheetPolicies/v2/getAccountWorkingDayTypes',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/TimeSheetPolicies', 'Get', '', true, '8ff8eac1-e847-44d1-9e00-059b145d9b17');
            const json = await response.json();
            return json;
        }
    )

export const getAccountWorkingDayTypeByAccountWorkingDayTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeSheetPolicies/v2/getAccountWorkingDayTypeByAccountWorkingDayTypeId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/TimeSheetPolicies/' + arg, 'Get', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const addAccountWorkingDayTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'timesheetpolicies/v2/addWorkingDayType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/timesheetpolicies/', 'POST', arg, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountWorkingDayTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'timesheetpolicies/v2/updateWorkingDayType',
        async (arg, thunkApi) => {
            const { AccountWorkingDayTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/timesheetpolicies/' + AccountWorkingDayTypeId, 'PUT', argWithoutId, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountWorkingDayTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'timesheetpolicies/v2/deleteAccountWorkingDayType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/timesheetpolicies/' + arg, 'DELETE', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const deleteSelectedAccountWorkingDayTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "timesheetpolicies/v2/DeleteSelectedAccountWorkingDayType",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/timesheetpolicies/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const workingdaytypeSlice = createSlice({
    name: 'workingdaytype',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.workingdaytypeList.findIndex((item) => item.AccountWorkingDayTypeId == action.payload);
            const newArray = [...state.workingdaytypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.workingdaytypeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.workingdaytypeList.findIndex((item) => item.AccountWorkingDayTypeId == action.payload);
            const newArray = [...state.workingdaytypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.workingdaytypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.workingdaytypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.workingdaytypeList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.workingdaytypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.workingdaytypeList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.workingdaytypeList;
            state.workingdaytypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountWorkingDayTypesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountWorkingDayTypesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //state.workingdaytypeList = payload;
                if (Object.keys(payload.Data).length === 0) {
                    state.workingdaytypeList = [];
                } else {
                    state.workingdaytypeList = payload.Data;
                    state.workingdaytypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountWorkingDayTypesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addAccountWorkingDayTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountWorkingDayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountWorkingDayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(updateAccountWorkingDayTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountWorkingDayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateAccountWorkingDayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(getAccountWorkingDayTypeByAccountWorkingDayTypeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountWorkingDayTypeByAccountWorkingDayTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.selectedRecord = payload.Data[0];
            })
            .addCase(getAccountWorkingDayTypeByAccountWorkingDayTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAccountWorkingDayTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountWorkingDayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAccountWorkingDayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(deleteSelectedAccountWorkingDayTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteSelectedAccountWorkingDayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteSelectedAccountWorkingDayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
    }
})

export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting, updatePagination
} = workingdaytypeSlice.actions
export const WorkingDayTypeState = (state: RootState) => state.workingdaytype
export default workingdaytypeSlice.reducer
